import { locationApis } from './Location';

export const subAdminApis = locationApis.injectEndpoints({
  endpoints: (builder) => ({
    getSubAdminList: builder.query({
      query: ({ page }) => `GetPinCodeAdmin?page=${page}`,
      providesTags: ['SubAdmin'],
    }),
    getSubAdminDetail: builder.query({
      query: (id) => `GetPinCodeAdminDetails/${id}`,
    }),
    addNewSubAdmin: builder.mutation({
      query: (body) => {
        return {
          url: `CreatePinCodeAdmin`,
          body,
          method: "POST"
        }
      },
      invalidatesTags: ['SubAdmin'],
    }),
    updateSubAdmin: builder.mutation({
      query: (body) => {
        const { id, formData } = body;
        return {
          url: `UpdatePinCodeAdmin/${id}`,
          body: formData,
          method: "PUT"
        }
      },
      invalidatesTags: ['SubAdmin'],
    }),
    deleteSubAdmin: builder.mutation({
      query: (id) => {
        return {
          url: `deleteAdmin/${id}`,
          method: "DELETE"
        }
      },
      invalidatesTags: ['SubAdmin'],
    }),
    statusChangeSubAdmin: builder.mutation({
      query: (body) => {
        const { id, formData } = body;
        return {
          url: `UpdatePinCodeAdminStatus/${id}`,
          body: formData,
          method: "PUT"
        }
      },
      invalidatesTags: ['SubAdmin'],
    }),
    statusChangePincodeAdmin: builder.mutation({
      query: (body) => {
        const { id, formData } = body;
        return {
          url: `UpdatePinCodeAdminStatus/${id}`,
          body: formData,
          method: "POST"
        }
      },
      invalidatesTags: ['SubAdmin'],
    }),
    getPincodeBySubAdmin: builder.query({
      query: (id) => `GetPinCodeByAdmin/${id}`,
      providesTags: ['SubAdmin'],
    }),
    getAdminByCity: builder.query({
      query: () => `AdminDropdownwithCity`,
    }),
    getPincodeByCity: builder.query({
      query: (cityId) => `GetPincodeByCity/${cityId}`,
      providesTags: ['SubAdmin'],
    }),
    // NEW ENDPOINT ADDED HERE
    getExtraPincodeByCity: builder.query({
      query: (cityId) => `GetExtraPincodeByCity/${cityId}`,
      providesTags: ['SubAdmin'],
    }),
  }),
});

export const {
  useGetSubAdminListQuery,
  useGetSubAdminDetailQuery,
  useAddNewSubAdminMutation,
  useUpdateSubAdminMutation,
  useDeleteSubAdminMutation,
  useStatusChangeSubAdminMutation,
  useGetPincodeBySubAdminQuery,
  useGetAdminByCityQuery,
  useStatusChangePincodeAdminMutation,
  useGetPincodeByCityQuery,
  useGetExtraPincodeByCityQuery, // NEW HOOK EXPORTED HERE
} = subAdminApis;